'use strict';

angular.module('shiftTraderApp')
  .service('DaysOffStore', ['$log', '$rootScope', 'Session', 'TimeService', 'AvailabilityRules', '$q', '$timeout',
    function ($log, $rootScope, Session, TimeService, AvailabilityRules, $q, $timeout) {
      var records = [];
      var cacheAgeByDate = {};
      var maxCacheAgeInSeconds = 60;
      var cacheAgeKeyFormat = 'MM-DD-YYYY';

      var anonymizeRequests = true;

      var batches = [];

      var dataRequests = [];

      function createBatch(request) {
        var newBatch = {
          open: true,
          startTime: request.startTime,
          endTime: request.endTime,
          requests: [request],
          timeout: $timeout(function() {
            processBatch(newBatch);
          }, 50)
        };
        batches.push(newBatch);

        return newBatch
      }

      function createDataRequest(startTime, endTime, callback) {
        var request = {
          startTime: startTime,
          endTime: endTime,
          callback: callback
        };
        dataRequests.push(request);

        return request;
      }

      function createOrAddRequestToBatch(request) {
        // check to see if there are any batches that:
        // open = true OR there is any overlap between request startTime/endTime and batch startTime/endTime

        var matchingBatch = _.find(batches, function(batch) {
          var twx = batch.startTime.twix(batch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          return batch.open &&
            ((reqTwix.overlaps(twx) && Math.abs(reqTwix.intersection(twx).length('minutes')) > 0)
            || batch.startTime.isSame(request.endTime, 'minute') || batch.endTime.isSame(request.startTime, 'minute'));
        });

        if (matchingBatch) {
          console.log('BATCH: FOUND a batching batch', matchingBatch);
          $timeout.cancel(matchingBatch.timeout);
          var twx = matchingBatch.startTime.twix(matchingBatch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          var union = twx.union(reqTwix);

          matchingBatch.startTime = union.start;
          matchingBatch.endTime = union.end;
          console.log('BATCH: new batch times: ', matchingBatch.startTime.format(), matchingBatch.endTime.format());

          matchingBatch.requests.push(request);
          matchingBatch.timeout = $timeout(function() {
            processBatch(matchingBatch);
          }, 50);

        } else {
          var z = createBatch(request);
          console.log('BATCH: CREATED NEW', z);
        }
      }


      function processBatch(batch) {
        batch.open = false;


        var startDate = TimeService.getBeginningOfDayFromDate(batch.startTime);

        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(batch.endTime).add(1, 'days');


        var data = {
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString(),
          type: 'daysoff'
        };

        if (anonymizeRequests) {
          data.anonymize = true;
        }

        AvailabilityRules.getAll(data)
          .then(function(rules) {
            that.updateCache(startDate, endDate, rules);

            _.each(batch.requests, function(request) {
              request.callback(request.startTime, request.endTime);
            });

          }, function() {
            request.callback(undefined);
          });
      }


      var that = this;

      this.setAnonymizeRequests = function(val) {
        anonymizeRequests = !!val;
        this.flush();
      };


      this.flush = function() {
        records = [];
        cacheAgeByDate = {};
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
        anonymizeRequests = false;
      });

      $rootScope.$on('updatedSessionMe', function() {
        if (Session.me) {
          var currentMembership = _.find(Session.me.memberships, {current: true});
          if (currentMembership && (currentMembership.role === 'admin' || currentMembership === 'manager') && anonymizeRequests === true) {
            that.setAnonymizeRequests(false);
          }
        }
      });

      function canUseCacheForRange(startDate, endDate) {
        // returns simple true or false;
        // IF cache can be used then return true, otherwise return false

        var currDate = moment(startDate);
        var acceptablePreviousTime = moment.utc().subtract(maxCacheAgeInSeconds, 'seconds');

        console.log('canUseCacheForRange', currDate.format(), acceptablePreviousTime.format());

        while (currDate.isBefore(endDate)) {
          var val = cacheAgeByDate[currDate.format(cacheAgeKeyFormat)];
          if (!val || (val.isBefore && val.isBefore(acceptablePreviousTime))) {
            console.log('cache insufficient', val, val && val.twix && val.twix(acceptablePreviousTime).length('seconds'), ' seconds');

            return false;
          }

          currDate.add(1, 'days');
          //console.log('currDate is now: ', currDate.format());
        }

        return true;
      }

      this.getDaysOffBetweenFromCache = function(startTime, endTime) {
        var range_twix = moment(startTime).twix(moment(endTime));
        console.log('getDaysOffBetweenFromCache', startTime.format(), endTime.format(), records.length);
        return _.where(records, function(record) {
          return record.range_twix.overlaps(range_twix) &&
              Math.abs(record.range_twix.intersection(range_twix).length('minutes')) > 0;
        });
      };

      this.addOrReplaceRecord = function(record) {
        var idx = _.findIndex(records, {id: record.id});

        if (idx > -1) {
          records[idx] = record;
        } else {
          records.push(record);
        }
      };

      this.addOrReplaceRecords = function(records) {
        _.each(records, that.addOrReplaceRecord);

      };

      this.updateCache = function(startDate, endDate, records) {
        console.log('updateRecords!', startDate.format(), endDate.format());
        var currDate = moment(startDate);
        var newTime = moment.utc();
        while (currDate.isBefore(endDate)) {
          cacheAgeByDate[currDate.format(cacheAgeKeyFormat)] = newTime.clone();

          currDate.add(1, 'days');
          //console.log('currDate is now: ', currDate.format());
        }

        console.log(cacheAgeByDate);
        that.addOrReplaceRecords(records);
        return true;
      };

      this.getDaysOffBetween = function(startTime, endTime, forceRequest) {
        var startDate = TimeService.getBeginningOfDayFromDate(startTime);

        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(endTime).add(1, 'days');

        var canUseCache = !forceRequest && canUseCacheForRange(startDate, endDate);
        console.log('startDate: ', startDate.format(), 'endDate: ', endDate.format(), ' -- what about that cache?', canUseCache);

        var deferred = $q.defer();

        if (canUseCache) {
          $timeout(function() {
            var x = that.getDaysOffBetweenFromCache(startTime, endTime);
            //console.log(x);
            deferred.resolve(x);
          }, 0);
        } else {

          var callback = function(startTime, endTime, rules) {
            if (startDate) {
              deferred.resolve(that.getDaysOffBetweenFromCache(startTime, endTime));
            } else {
              deferred.reject();
            }
          };

          createOrAddRequestToBatch(createDataRequest(startTime, endTime, callback));
        }

        return deferred.promise;
      };

      this.getDaysOffIntersectingDate = function(dt) {
        var dtTwix = TimeService.getDayTwixFromDate(dt);

        //console.log('dtDtwix', dtTwix.format(), 'from', dt.format());

        return that.getDaysOffBetween(dtTwix.start, dtTwix.end);

        //return _(allDaysOff).where(function(dayOff) {
        //  return dayOff.range_twix.overlaps(dtTwix) &&
        //    Math.abs(dayOff.range_twix.intersection(dtTwix).length('minutes')) > 0 &&
        //    dayOff.range_twix.end.isAfter(moment(dt).add(Session.getWorkDayStartHour(), 'hours'), 'minute');
        //}).value();
      };

      this.getRecordById = function(recordId) {
        console.log(recordId, _.find(records, {id: recordId}));
        return _.find(records, {id: recordId});
      };

  }]);
